import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-s-clock",
  "use": "icon-s-clock-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"icon-s-clock\"><path d=\"M11 0c6.077 0 11 4.923 11 11s-4.923 11-11 11S0 17.077 0 11 4.923 0 11 0m0 2.129A8.87 8.87 0 0 0 2.129 11 8.87 8.87 0 0 0 11 19.871 8.87 8.87 0 0 0 19.871 11 8.87 8.87 0 0 0 11 2.129m.71 2.13c.292 0 .532.239.532.531v6.285l2.963 2.156c.24.173.288.506.115.745l-.834 1.149a.536.536 0 0 1-.745.115l-3.766-2.736a.54.54 0 0 1-.217-.43V4.79c0-.292.24-.532.532-.532Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol